export default "__VITE_PUBLIC_ASSET__1ae342da__"